import { Component } from "preact";

import UserHome from "./UserHome";
import trapFocus from "../../utils/trapFocus";

import style from "./index.scss";
import ReportIssueV2 from "./ReportIssueV2";

export default class User extends Component {
  constructor(props) {
    super(props);

    this.updateContent = this.updateContent.bind(this);
    this.state = {
      currentContent: "Home",
    };
    this.focusCleanup = null;
  }

  componentDidMount() {
    this.focusCleanup = trapFocus(true);
    if (this.props.payload.initialPage === "AccessibilityIssueV2") {
      this.updateContent("AccessibilityIssueV2", {
        title: "Accessibility Issue Page",
      });
    }
  }

  componentDidUpdate() {
    if (this.focusCleanup) {
      this.focusCleanup();
    }
    this.focusCleanup = trapFocus();
  }

  componentWillUnmount() {
    if (this.focusCleanup) {
      this.focusCleanup();
    }
  }

  updateContent(contentName, data = {}) {
    this.setState({
      currentContent: contentName,
      data: data,
    });
    this.switchContent();
  }

  switchContent() {
    const { currentContent, data } = this.state;
    switch (currentContent) {
      case "Home":
        return (
          <UserHome
            onContentClick={this.updateContent}
            payload={this.props.payload}
          />
        );
      case "ShowAdditionalButtons":
        return (
          <UserHome
            onContentClick={this.updateContent}
            payload={this.props.payload}
            type="showButtons"
          />
        );
      case "ReportIssueV2":
        return (
          <ReportIssueV2
            type="bug"
            title={data && data.title}
            onContentClick={this.updateContent}
            closeModal={this.props.closeModal}
            payload={this.props.payload}
          />
        );
      case "featureRequest":
        return (
          <ReportIssueV2
            type="featureRequest"
            title={data && data.title}
            onContentClick={this.updateContent}
            closeModal={this.props.closeModal}
            payload={this.props.payload}
          />
        );
      case "AccessibilityIssueV2":
        return (
          <ReportIssueV2
            type="accessibility"
            title={data && data.title}
            onContentClick={this.updateContent}
            closeModal={this.props.closeModal}
            payload={this.props.payload}
          />
        );
      default:
        return (
          <UserHome
            onContentClick={this.updateContent}
            payload={this.props.payload}
          />
        );
    }
  }

  render() {
    return <div class={style.userBody}>{this.switchContent()}</div>;
  }
}



// WEBPACK FOOTER //
// ./components/User/index.js